<template>
  <div class="climate-smart-ppp-tab">
    <div class="tab-header">
      <h2>Climate-Smart PPP</h2>
      <p class="tab-description">
        Sustainable development and climate resilience
      </p>
    </div>

    <form @submit.prevent="validateAndSubmit" class="project-form">
      
      <!-- Section A: Climate-smart Project scoping -->
      <section class="form-section">
        <div class="section-header">
          <h3>Section A: Climate-smart Project scoping</h3>
        </div>
        
        <div class="form-grid">
          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">1. Is the project envisaged to adopt nature-based solutions (NbS) to address climate change mitigation, adaptation and resilience features?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q1" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q1" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q1" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q1" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q1" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionA_q1_comments">Comments</label>
            <textarea 
              id="sectionA_q1_comments"
              v-model="formData.sectionA_q1_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">2. Will a baseline mitigation target for GHG emissions be set and declared for the project?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q2" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q2" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q2" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q2" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q2" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionA_q2_comments">Comments</label>
            <textarea 
              id="sectionA_q2_comments"
              v-model="formData.sectionA_q2_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">3. Do the project's proposed mitigation measures partially compensate for the project's expected GHG emissions?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q3" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q3" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q3" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q3" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q3" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionA_q3_comments">Comments</label>
            <textarea 
              id="sectionA_q3_comments"
              v-model="formData.sectionA_q3_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">4. Are the proposed structural and/or management adaptation measures resilient to changes in climate conditions during the lifespan of the project?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q4" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q4" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q4" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q4" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q4" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionA_q4_comments">Comments</label>
            <textarea 
              id="sectionA_q4_comments"
              v-model="formData.sectionA_q4_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>
        </div>
      </section>

      <!-- Section B: Design, construction and O&M -->
      <section class="form-section">
        <div class="section-header">
          <h3>Section B: Design, construction and O&M</h3>
        </div>
        
        <div class="form-grid">
          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">1. Does the project's design consider structural adaptation measures, including potential technological options, to reflect a CCVA?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q1" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q1" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q1" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q1" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q1" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionB_q1_comments">Comments</label>
            <textarea 
              id="sectionB_q1_comments"
              v-model="formData.sectionB_q1_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">2. Will the project's performance standards cover defined and measurable climate resilient key performance indicators (KPIs) with an incentive mechanism for the private sector to perform effectively and efficiently?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q2" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q2" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q2" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q2" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q2" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionB_q2_comments">Comments</label>
            <textarea 
              id="sectionB_q2_comments"
              v-model="formData.sectionB_q2_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">3. Will the project performance standards/ KPIs include the accounting of GHG emissions and targets?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q3" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q3" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q3" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q3" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q3" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionB_q3_comments">Comments</label>
            <textarea 
              id="sectionB_q3_comments"
              v-model="formData.sectionB_q3_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">4. Has the proposed project included appropriate management adaptation measures to reflect the results of the CCVA?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q4" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q4" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q4" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q4" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q4" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionB_q4_comments">Comments</label>
            <textarea 
              id="sectionB_q4_comments"
              v-model="formData.sectionB_q4_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">5. Does the project's capex and/or operating expenditure (opex) include the cost of climate change adaptation measures such as structural and/or management elements?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q5" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q5" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q5" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q5" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q5" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionB_q5_comments">Comments</label>
            <textarea 
              id="sectionB_q5_comments"
              v-model="formData.sectionB_q5_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">6. Does the contracting agency plan to provide project-related training on climate change vulnerability assessments, mitigation and adaption measures, and monitoring mechanisms to its staff?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q6" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q6" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q6" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q6" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q6" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionB_q6_comments">Comments</label>
            <textarea 
              id="sectionB_q6_comments"
              v-model="formData.sectionB_q6_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>
        </div>
      </section>

      <!-- Section C: Economic and Social sustainability -->
      <section class="form-section">
        <div class="section-header">
          <h3>Section C: Economic and Social sustainability</h3>
        </div>
        
        <div class="form-grid">
          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">1. Does project design and operation address the displacement of population due to climate change events during the lifetime of the PPP project?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q1" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q1" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q1" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q1" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q1" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionC_q1_comments">Comments</label>
            <textarea 
              id="sectionC_q1_comments"
              v-model="formData.sectionC_q1_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">2. Have the climate change impacts (including GHG emissions) and the effects of the climate adaptation measures on the wider society been considered as part of an economic analysis (quantitative) for the project, and has this analysis been completed?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q2" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q2" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q2" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q2" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q2" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionC_q2_comments">Comments</label>
            <textarea 
              id="sectionC_q2_comments"
              v-model="formData.sectionC_q2_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>
        </div>
      </section>

      <!-- Section D: Financial analysis -->
      <section class="form-section">
        <div class="section-header">
          <h3>Section D: Financial analysis</h3>
        </div>
        
        <div class="form-grid">
          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">1. Have the financial parameters/ratios (e.g., IRR, NPV, return on investment (ROI)) been evaluated, taking into account the climate adaptation/mitigation measures?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q1" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q1" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q1" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q1" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q1" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionD_q1_comments">Comments</label>
            <textarea 
              id="sectionD_q1_comments"
              v-model="formData.sectionD_q1_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">2. Has the value for money (VFM) assessment considered the climate change risk allocation between the parties?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q2" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q2" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q2" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q2" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q2" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionD_q2_comments">Comments</label>
            <textarea 
              id="sectionD_q2_comments"
              v-model="formData.sectionD_q2_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">3. Will the project be eligible for fiscal incentives from the government for climate change adaptation or mitigation?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q3" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q3" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q3" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q3" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q3" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionD_q3_comments">Comments</label>
            <textarea 
              id="sectionD_q3_comments"
              v-model="formData.sectionD_q3_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>
        </div>
      </section>

      <!-- Section E: Procurement process -->
      <section class="form-section">
        <div class="section-header">
          <h3>Section E: Procurement process</h3>
        </div>
        
        <div class="form-grid">
          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">1. Will the project be procured using the green public procurement (GPP) procedures?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q1" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q1" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q1" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q1" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q1" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionE_q1_comments">Comments</label>
            <textarea 
              id="sectionE_q1_comments"
              v-model="formData.sectionE_q1_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">2. Can potential transition risks be mitigated through provisions in the bid documents and/or project agreement?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q2" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q2" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q2" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q2" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q2" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionE_q2_comments">Comments</label>
            <textarea 
              id="sectionE_q2_comments"
              v-model="formData.sectionE_q2_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">3. Have PPP projects that had considered climate change adaptability been successfully implemented in the country or region?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q3" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q3" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q3" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q3" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q3" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionE_q3_comments">Comments</label>
            <textarea 
              id="sectionE_q3_comments"
              v-model="formData.sectionE_q3_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>
        </div>
      </section>

    </form>
  </div>
</template>

<script>
export default {
  name: 'ClimateSmartPPPTab',
  props: {
    projectData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {
        // Section A: Climate-smart Project scoping
        sectionA_q1: '',
        sectionA_q1_comments: '',
        sectionA_q2: '',
        sectionA_q2_comments: '',
        sectionA_q3: '',
        sectionA_q3_comments: '',
        sectionA_q4: '',
        sectionA_q4_comments: '',
        
        // Section B: Design, construction and O&M
        sectionB_q1: '',
        sectionB_q1_comments: '',
        sectionB_q2: '',
        sectionB_q2_comments: '',
        sectionB_q3: '',
        sectionB_q3_comments: '',
        sectionB_q4: '',
        sectionB_q4_comments: '',
        sectionB_q5: '',
        sectionB_q5_comments: '',
        sectionB_q6: '',
        sectionB_q6_comments: '',
        
        // Section C: Economic and Social sustainability
        sectionC_q1: '',
        sectionC_q1_comments: '',
        sectionC_q2: '',
        sectionC_q2_comments: '',
        
        // Section D: Financial analysis
        sectionD_q1: '',
        sectionD_q1_comments: '',
        sectionD_q2: '',
        sectionD_q2_comments: '',
        sectionD_q3: '',
        sectionD_q3_comments: '',
        
        // Section E: Procurement process
        sectionE_q1: '',
        sectionE_q1_comments: '',
        sectionE_q2: '',
        sectionE_q2_comments: '',
        sectionE_q3: '',
        sectionE_q3_comments: ''
      },
      errors: {},
      showValidation: false
    }
  },
  computed: {
    isValid() {
      return this.validateForm().isValid
    }
  },
  watch: {
    projectData: {
      handler(newData) {
        if (newData && Object.keys(newData).length > 0) {
          this.formData = { ...this.formData, ...newData }
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    updateData() {
      this.$emit('update', this.formData)
      this.validateForm()
    },
    validateForm() {
      this.errors = {}
      let isValid = true

      this.showValidation = true
      this.$emit('validate', isValid)
      
      return { isValid, errors: this.errors }
    },
    validateAndSubmit() {
      this.validateForm()
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.validateForm()
    })
  }
}
</script>

<style scoped>
.climate-smart-ppp-tab {
  max-width: 1000px;
  margin: 0 auto;
}

.tab-header {
  text-align: center;
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 2px solid #e9ecef;
}

.tab-header h2 {
  font-size: 2rem;
  color: #333;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.tab-description {
  color: #666;
  font-size: 1.1rem;
  line-height: 1.6;
  max-width: 600px;
  margin: 0 auto;
}

.form-section {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 2rem;
  border-left: 4px solid #00338d;
}

.section-header {
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #dee2e6;
}

.section-header h3 {
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-group label {
  font-weight: 600;
  color: #333;
  margin-bottom: 0.5rem;
  display: block;
}

.form-group textarea {
  padding: 0.75rem;
  border: 2px solid #e0e6ed;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s, box-shadow 0.3s;
  background: white;
  resize: vertical;
  min-height: 100px;
  font-family: inherit;
}

.form-group textarea:focus {
  outline: none;
  border-color: #00338d;
  box-shadow: 0 0 0 3px rgba(0, 51, 141, 0.1);
}

.checkbox-label {
  display: block !important;
}

.checkbox-text {
  font-weight: 600;
  color: #333;
  margin-bottom: 1rem;
  display: block;
}

.radio-group {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  gap: 0.75rem;
  margin-top: 0.75rem;
  align-items: stretch;
}

.radio-option {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-weight: 500;
  padding: 0.75rem 1rem;
  min-height: 40px;
  position: relative;
  transition: all 0.2s ease;
  border-radius: 8px;
  border: 2px solid #d1d5db;
  background: #ffffff;
  color: #374151;
  text-align: center;
}

.radio-option input[type="radio"] {
  display: none;
}

.radio-option:has(input[type="radio"]:checked) {
  background: #00338d;
  border-color: #00338d;
  color: white;
  font-weight: 600;
  box-shadow: 0 0 0 2px rgba(0, 51, 141, 0.2);
}

.radio-option:hover {
  background-color: #e8f0fe;
  border-color: #00338d;
  color: #00338d;
}

.radio-option:hover:has(input[type="radio"]:checked) {
  background: #002966;
  border-color: #002966;
  color: white;
}

.radio-option:has(input[type="radio"]:focus) {
  border-color: #00338d;
  box-shadow: 0 0 0 3px rgba(0, 51, 141, 0.1);
  outline: none;
}

/* Responsive Design */
@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
  
  .radio-group {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.75rem;
    margin-top: 0.5rem;
  }
  
  .radio-option {
    padding: 0.75rem 0.75rem;
    min-height: 44px;
    font-size: 0.95rem;
  }
  
  .form-section {
    padding: 1rem;
  }
}

@media (max-width: 480px) {
  .radio-group {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
  
  .radio-option {
    padding: 1rem 0.75rem;
    min-height: 48px;
    font-size: 0.9rem;
  }
}
</style>